/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
import colors from "assets/theme/base/colors";

// Material Dashboard 2 React helper functions
import rgba from "assets/theme/functions/rgba";
import pxToRem from "assets/theme/functions/pxToRem";

const { grey, transparent, white } = colors;

// Gạch chỉ đặc (không mờ dần 2 đầu) — đúng ngôn ngữ "chứng từ" của redesign
// (xem trang-chu/quan-ly-hop-tac-xa/ChonChuVuon Giai đoạn B), để các trang
// sau không phải tự dựng hairline bằng MDBox nữa.
const divider = {
  styleOverrides: {
    root: {
      backgroundColor: grey[300],
      height: pxToRem(1),
      margin: `${pxToRem(16)} 0`,
      border: "none",
      opacity: 1,
    },

    vertical: {
      backgroundColor: grey[300],
      width: pxToRem(1),
      height: "100%",
      margin: `0 ${pxToRem(16)}`,
      border: "none",
    },

    light: {
      backgroundColor: transparent.main,
      backgroundImage: `linear-gradient(to right, ${rgba(white.main, 0)}, ${white.main}, ${rgba(
        white.main,
        0
      )}) !important`,

      "&.MuiDivider-vertical": {
        backgroundImage: `linear-gradient(to bottom, ${rgba(white.main, 0)}, ${white.main}, ${rgba(
          white.main,
          0
        )}) !important`,
      },
    },
  },
};

export default divider;
